// extracted by mini-css-extract-plugin
export default {"generated-access-token":"ScIGHj7pt5FJz2j8Ajts","copy-text-container":"ZlfHZTEBy6SLJeRZ8Qdo"};